import React, { useState, useEffect } from 'react';

const UserTeardown = ({ user }) => {
    const [roast, setRoast] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [loadingPhase, setLoadingPhase] = useState(0);

    const API_BASE = process.env.REACT_APP_API_BASE;
    const API_KEY = process.env.REACT_APP_API_KEY;

    const loadingMessages = [
        "Analyzing your questionable film choices...",
        "Preparing your roast, please be patient..."
    ];

    const fetchRoast = async () => {
        setLoading(true);
        setError(null);
        setLoadingPhase(0);

        try {
            const response = await fetch(`${API_BASE}/v1/dweeb/roast`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-Key': API_KEY,
                    'X-User-ID': user.id,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to generate roast');
            }

            const data = await response.json();
            setRoast(data.roast);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!user) return;
        fetchRoast();
    }, [user, API_BASE, API_KEY]);

    // Cycle through loading messages
    useEffect(() => {
        if (!loading) return;

        const interval = setInterval(() => {
            setLoadingPhase((prev) => (prev + 1) % loadingMessages.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [loading, loadingMessages.length]);

    if (loading) {
        return (
            <div className="max-w-3xl mx-auto p-8">
                <div className="bg-gray-900 rounded-lg p-8 text-center">
                    <div className="text-6xl mb-4 animate-bounce">🤡</div>
                    <p className="text-gray-400">{loadingMessages[loadingPhase]}</p>
                    <div className="flex justify-center mt-4 space-x-1">
                        <div className="w-2 h-2 bg-gray-600 rounded-full animate-pulse"></div>
                        <div className="w-2 h-2 bg-gray-600 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                        <div className="w-2 h-2 bg-gray-600 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="max-w-3xl mx-auto p-8">
                <div className="bg-gray-900 rounded-lg p-8 text-center">
                    <div className="text-6xl mb-4">🤡</div>
                    <p className="text-red-400">Error: {error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-3xl mx-auto p-8">
            <div className="bg-gray-900 rounded-lg p-8">
                <div className="text-center mb-6">
                    <div className="text-6xl mb-2">🤡</div>
                    <h1 className="text-2xl font-bold text-white mb-2">Film Taste Analysis</h1>
                    <p className="text-gray-400 text-sm">Based on your viewing history and reviews</p>
                </div>

                <div className="bg-gray-800 rounded-lg p-6">
                    <p className="text-white text-lg leading-relaxed whitespace-pre-wrap">{roast}</p>
                </div>

                <div className="mt-6 text-center">
                    <button
                        onClick={fetchRoast}
                        className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-md text-sm transition-colors"
                    >
                        Get Roasted Again
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserTeardown;